module.exports = __webpack_public_path__ + "static/media/1012581.da37fefd.jpg";